<template>
  <div>
    <!-- 저장하기 버튼 -->
    <div class="btn-group-justify-end" v-if="isAuth">
      <button class="button is-primary" @click="openRegModal">관리자 등록</button>
    </div>
    <div class="box">
      <admin-box-item title="관리자 목록" tip="관리자 등록 권한은 대표관리자에게만 있으며, 각 관리자는 비밀번호 변경, 수정을 할 수 있습니다.">

        <!-- 관리자 목록 -->
        <div style="overflow-x: auto">
        <table class="table">
          <tbody>
          <tr>
            <th>index</th>
            <th>생성일</th>
            <th>아이디</th>
            <th>이름</th>
            <th>이메일</th>
            <th>휴대전화번호</th>
            <th>비밀번호변경</th>
            <th>수정</th>
          </tr>
          <tr v-for="(item, idx) in tableItem" :key="'table-item-'+item.id">
            <td>{{ tableItem.length - idx }}</td>
            <td>{{ item.created_time }}</td>
            <td>{{ item.username }}</td>
            <td>{{ item.name }}</td>
            <td>{{ item.email }}</td>
            <td>{{ item.phone }}</td>
            <td>
              <button class="button" @click="modifyPasswordModal(item)" v-if="isMasterOrMine(item)">패스워드 변경</button>
            </td>
            <td>
              <button class="button" @click="modifyInfoModal(item)" v-if="isMasterOrMine(item)">정보수정</button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      </admin-box-item>
    </div>
  </div>
</template>

<script>
  import BreadCrumb from '../../module/common/BreadCrumb'
  import { SweetModal } from "sweet-modal-vue";
  import LpInputText from "../../module/common/LpInputText";
  import LpAdmDropInput from "../../module/common/LpAdmDropInput";
  import AdminFormItem from "../../module/admin/AdminFormItem";


  export default {
    components: {
      AdminFormItem,
      LpAdmDropInput,
      LpInputText,
       SweetModal
    },
    created() {
      this.getData();

    },
    data() {
      return {
        tableItem: [],
        selected:{
          id:'',
          password:'',
          passwordCheck:'',
          username:'',
          name:'',
          email:'',
          phone:''
        },
        errMsg:''
      }
    },
    computed: {
      isAuth() {
        if (this.$store.getters.admin.auth < 2) return true;
        else return false;
      },
    },
    watch: {
      modalStatus(n) {
        if(n==='close'){
          this.getData();
        }
      }
    },
    methods: {
      isMasterOrMine(item) {
        if(item.id===this.$store.getters.admin.id) return true
        else if(this.$store.getters.admin.auth < 2) return true;
        else return false;
      },
      getData() {
        this.$axios.get('admin/member/admin').then(res => {
          if (res.status === 200) {
            this.tableItem = res.data;
          }
        })
      },
      // 등록
      openRegModal(){
        let value = {
          id:'',
          password:'',
          passwordCheck:'',
          username:'',
          email:'',
          name:'',
          type:'create'
        }

        this.$store.commit('openModal', {type: 'modal-admin-create', value: value, background:false});
      },
      // 수정
      modifyInfoModal(item){
        let value = {
          id:item.id,
          password:'',
          passwordCheck:'',
          username:item.username,
          name:item.name,
          email:item.email,
          phone:item.phone,
          type:'modify'
        }

        this.$store.commit('openModal', {type: 'modal-admin-create', value: value, background:false});
      },
      // 등록 모달 끄기
      closeRegModal(){
        this.errMsg='';
        this.selected = {
          id:'',
          name:'',
          email:'',
          password:'',
          passwordCheck:'',
          username:'',
          phone: ''
        }
      },
      // 비밀번호 수정
      modifyPasswordModal(item){
        let value = {
          id:item.id,
          password:'',
          passwordCheck:'',
          username:item.username,
          name:item.name,
          email:item.email,
          phone:item.phone,
          type:'password'
        }

        this.$store.commit('openModal', {type: 'modal-admin-create', value: value, background:false});
      },
      /*// 선택
      selectAdmin(res){
        this.selected.auth = res.value;
      }*/
    }
  }
</script>

<style lang="stylus" type="stylus" scoped>
  //@import '~assets/css/reset'
  @import '~assets/css/lp_main'

  .modal-title
    margin 20px 0 8px 0
    color #064160
    font-size 0.9rem
    font-weight bold

  .modal-desc
    padding 20px
    background-color #eee

  .btn-update
  .btn-delete
    padding 4px 10px
    margin 4px
    display inline-block

  @media (max-width: 600px)
    .is-mobile-modal
      margin-top 57px

</style>
